import React from "react";
import StatusBadge from "./StatusBadge";

const RequestDetailsModal = ({ request, onClose }) => {
  if (!request) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: 'white',
          borderRadius: '16px',
          padding: '30px',
          maxWidth: '600px',
          width: '100%',
          maxHeight: '90vh',
          overflowY: 'auto',
          boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666',
            padding: '4px'
          }}
        >
          ×
        </button>

        {/* Header */}
        <div style={{ marginBottom: '25px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '600', 
            color: '#1a3c34', 
            margin: '0 0 10px 0' 
          }}>
            Request Details
          </h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <StatusBadge status={request.status} />
            <span style={{ fontSize: '14px', color: '#666' }}>
              Submitted: {formatDate(request.created_at)}
            </span>
          </div>
        </div>

        {/* Request Type */}
        <div style={{ 
          backgroundColor: '#f8fafc', 
          padding: '15px', 
          borderRadius: '8px', 
          marginBottom: '20px' 
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <span style={{ fontWeight: '600', color: '#333' }}>Request Type:</span>
            <span style={{ 
              backgroundColor: '#2a9d8f', 
              color: 'white', 
              padding: '4px 12px', 
              borderRadius: '20px', 
              fontSize: '14px' 
            }}>
              {request.type}
            </span>
          </div>
        </div>

        {/* Service/Vendor Information */}
        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#1a3c34', 
            marginBottom: '12px' 
          }}>
            {request.type === 'Service Request' ? 'Service Details' : 'Request Details'}
          </h3>
          
          {request.type === 'Service Request' ? (
            <div style={{ 
              backgroundColor: '#f0f9ff', 
              padding: '15px', 
              borderRadius: '8px',
              border: '1px solid #bae6fd'
            }}>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: '#0369a1' }}>Vendor:</strong>
                <div style={{ fontSize: '16px', marginTop: '4px' }}>
                  {request.vendor_name || 'Unknown Vendor'}
                </div>
              </div>
              <div>
                <strong style={{ color: '#0369a1' }}>Service:</strong>
                <div style={{ fontSize: '16px', marginTop: '4px' }}>
                  {request.service_name || 'Service Request'}
                </div>
              </div>
            </div>
          ) : (
            <div style={{ 
              backgroundColor: '#f0f9ff', 
              padding: '15px', 
              borderRadius: '8px',
              border: '1px solid #bae6fd'
            }}>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: '#0369a1' }}>Service Type:</strong>
                <div style={{ fontSize: '16px', marginTop: '4px' }}>
                  {request.service_name || 'Concierge Request'}
                </div>
              </div>
              <div>
                <strong style={{ color: '#0369a1' }}>Request Category:</strong>
                <div style={{ fontSize: '16px', marginTop: '4px' }}>
                  Concierge Services
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Contact Information */}
        {request.email && (
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ 
              fontSize: '18px', 
              fontWeight: '600', 
              color: '#1a3c34', 
              marginBottom: '12px' 
            }}>
              Contact Information
            </h3>
            <div style={{ 
              backgroundColor: '#f0fdf4', 
              padding: '15px', 
              borderRadius: '8px',
              border: '1px solid #bbf7d0'
            }}>
              <strong style={{ color: '#166534' }}>Email:</strong>
              <div style={{ fontSize: '16px', marginTop: '4px' }}>
                {request.email}
              </div>
            </div>
          </div>
        )}

        {/* Message/Description */}
        {request.message && (
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ 
              fontSize: '18px', 
              fontWeight: '600', 
              color: '#1a3c34', 
              marginBottom: '12px' 
            }}>
              Request Message
            </h3>
            <div style={{ 
              backgroundColor: '#fafafa', 
              padding: '15px', 
              borderRadius: '8px',
              border: '1px solid #e5e5e5'
            }}>
              <div style={{ 
                fontSize: '15px', 
                lineHeight: '1.5', 
                color: '#333',
                whiteSpace: 'pre-wrap'
              }}>
                {request.message}
              </div>
            </div>
          </div>
        )}

        {/* Additional Information */}
        <div style={{ 
          backgroundColor: '#fffbeb', 
          padding: '15px', 
          borderRadius: '8px',
          border: '1px solid #fde68a'
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
            <span style={{ fontSize: '18px' }}>ℹ️</span>
            <div>
              <strong style={{ color: '#b45309' }}>Next Steps:</strong>
              <p style={{ 
                margin: '5px 0 0 0', 
                fontSize: '14px', 
                color: '#b45309' 
              }}>
                Our team will review your request and contact you soon. 
                You can track the status of this request in the Request History section.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestDetailsModal;